import type { HqApi } from '@hq/api-sdk';
import { useQueryClient } from '@tanstack/react-query';
import { ScreenScanConfirm } from './ScreenScanConfirm';

export interface ScreenScanPageProps {
  /** 已登录会话的 SDK 实例（各端注入）。 */
  hq: HqApi;
}

/**
 * 「申请码确认」页面壳：确认成功后统一刷新大屏相关查询。
 *
 * 四端（hospital/ops/system/gov）此前各自 22 行重复这段 refresh 逻辑，
 * 其中 system 端有、另外三端遗漏过（授权后设备列表不刷新），故收进包内，避免再次漏写。
 */
export function ScreenScanPage({ hq }: ScreenScanPageProps) {
  const queryClient = useQueryClient();

  return (
    <ScreenScanConfirm
      hq={hq}
      onApproved={() => {
        // 待确认列表 key=['screen-device','pending']、设备列表 key=['screen-device', tenantId]
        void queryClient.invalidateQueries({ queryKey: ['screen-device'] });
      }}
    />
  );
}
